import React from 'react';
import { Container, Typography, Box, Link, styled } from '@mui/material';

const FooterContainer = styled('footer')(({ theme }) => ({
  backgroundColor: '#f9f9f9',
  padding: theme.spacing(3, 0),
  marginTop: 'auto',
  borderTop: '1px solid #e0e0e0',
}));

const FooterContent = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
});

const LinkContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  flexWrap: 'wrap',
  margin: theme.spacing(1, 0),
}));

const FooterLink = styled(Link)(({ theme }) => ({
  margin: theme.spacing(0, 2),
  color: theme.palette.text.secondary,
  textDecoration: 'none',
  fontSize: '0.875rem',
  '&:hover': {
    color: theme.palette.primary.main,
    textDecoration: 'underline',
  },
}));

const Copyright = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: '0.75rem',
  marginTop: theme.spacing(1),
}));

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <FooterContainer>
      <Container maxWidth="md">
        <FooterContent>
          <LinkContainer>
            <FooterLink href="https://zgallerie.com/customer-service/privacy-policy/">Privacy Policy</FooterLink>
            <FooterLink href="https://zgallerie.com/customer-service/terms-and-conditions">Terms of Service</FooterLink>
            <FooterLink href="https://zgallerie.com/customer-service/customer-service">Contact Us</FooterLink>
            <FooterLink href="https://zgallerie.com/t-about">About Us</FooterLink>
            <FooterLink href="https://zgallerie.com/t-track-order">Search Order</FooterLink>
          </LinkContainer>
          
          <Copyright>
            © {currentYear} Z Gallerie. All rights reserved.
          </Copyright>
        </FooterContent>
      </Container>
    </FooterContainer>
  );
};

export default Footer; 